import { CategoryParamEntity } from '@shared/domain/products/category-param.entity';
import { BaseRootEntity } from '@shared/entity/base-root-entity';
import { TreeEntity } from '@shared/model/trees';
import { Field } from '@tsim/model';

export class CategoryEntity extends BaseRootEntity implements TreeEntity {
  @Field(String, true)
  name!: string;

  @Field(String, true)
  fullName!: string;

  @Field(String, false)
  url?: string;

  @Field(String, false)
  keywords?: string;

  @Field(String, false)
  description?: string;

  @Field(Number, false)
  position?: number;

  @Field([CategoryParamEntity], true)
  productParams: CategoryParamEntity[] = [];

  @Field(String, false)
  path?: string;

  @Field(String, false)
  parentId?: string;

  @Field(CategoryEntity, false)
  parent?: CategoryEntity;

  @Field([CategoryEntity], false)
  children?: CategoryEntity[];
}
